import type { TooltipProps as AntdTooltipProps } from 'antd';
import { Tooltip as AntdTooltip } from 'antd';
import classNames from 'classnames';

import styles from './Tooltip.module.css';

type TooltipProps = {
  title: React.ReactNode;
  children: React.ReactNode;
  rootClassName?: string;
} & Omit<AntdTooltipProps, 'title' | 'rootClassName'>;

const Tooltip = ({ title, children, rootClassName, ...props }: TooltipProps) => {
  return (
    <AntdTooltip title={title} rootClassName={classNames(styles.tooltip, rootClassName)} arrow={false} {...props}>
      {children}
    </AntdTooltip>
  );
};

export { Tooltip };
export type { TooltipProps };
